import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  text: {
    fill: '#ffffff',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 700,
    fontSize: '18px',
  },
  sub: {
    fill: '#9e9e9e',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 400,
    fontSize: '12px',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 30">
      <text className={classes.text} x="0" y="20">
        AGM
      </text>
      <text className={classes.sub} x="58" y="21">
        DevHub
      </text>
    </svg>
  );
};
